import { lazy } from 'react';
import Loadable from 'components/Loadable';

const DashboardView = Loadable(lazy(() => import('./components/dashboard-view/DashboardView')));

export const dashboardRoutes = {
  path: 'dashboard',
  children: [
    { index: true, element: <DashboardView /> },
    { path: 'default', element: <DashboardView /> }
  ]
};

export default dashboardRoutes;
